import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      modal, // currently selected modal (via redux state)
      modalId, // this modal (via props)
      setModal // from redux actions
    } = props

    const handleClose = e => {
      e.preventDefault()
      setModal({ open: false })
    }

    // On exit, set "open" state to false if it isn't already. This is to handle
    // a dialog that were closed e.g. by clicking the backdrop, so it won't be
    // open the next time the component renders.
    const handleExit = () => {
      if (modal.id === modalId && modal.open === true) {
        setModal({ open: false })
      }
    }

    return (
      <WrappedComponent
        handleClose={handleClose}
        handleExit={handleExit}
        {...props}
      />
    )
  }
}

export default withEventHandlers
